import styled from 'styled-components'

const WrappedCorouselStyle = styled.div`
    font-family: Muli !important;
`;

export default WrappedCorouselStyle


// WEBPACK FOOTER //
// ./src/component/common/corousel.style.js